import { render, staticRenderFns } from "./LocationsMapWidget.vue?vue&type=template&id=a954f954"
import script from "./LocationsMapWidget.vue?vue&type=script&lang=js"
export * from "./LocationsMapWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports